import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import {AppDataService} from "../../../../services/app-data.service";
import { CompanyService }  from '../../../../services/company.service';

declare let $: any;
declare let Swal:any;

@Component({
    selector : 'level-screen',
    templateUrl:'level-screen.html'
})
export class LevelScreenComponent implements OnInit, OnDestroy{

  public user;
  public popularity;
  public popularityLevel;
  public nextPopularityLevel;

  public constructor( private _router : Router,public _appData : AppDataService,private _companyService : CompanyService) {
  }
  public ngOnInit(): any {
    this.user=this._appData.instagramUser;
    this.popularity=this.user.popularity;
    this.popularityLevel=this.user.popularityLevel;
    if (!this.popularityLevel) this.popularityLevel=1;
    if (!this.popularity) this.popularity=0;

    this.nextPopularityLevel=Math.pow(2,this.popularityLevel-1)*1000;
    this._companyService.getUserByUid(this._appData.instagramUser.uid).then(snap=>{
      this._appData.instagramUser=snap.data();
      this.popularity=this.user.popularity;
      this.popularityLevel=this.user.popularityLevel;
      if (!this.popularityLevel) this.popularityLevel=1;
      if (!this.popularity) this.popularity=0; 
    })

  }
  public livecoinsTutorial(){
    Swal.fire({
      title:'O que é livecoin?',
      text:'Livecoins são usadas para comprar roupas de avatar, jogos especiais e obter entradas vip para festas reais. Você ganha livecoins passando de nível nos diversos módulos do jogo.'
    })
  }
  public popularityTutorial(){
    Swal.fire({
      title:'O que é popularidade?',
      text:'Popularidade é um módulo do jogo que mede o quão bem você se relaciona com outros jogadores. Ganhe pontos fazendo contatos com outros jogadores.'
    })

  }
  public ngOnDestroy() : any {
  }

}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/cellphone-modal/level-screen/level-screen.ts